<div>
  <label> {{ 'user.residentType' | loc }} </label>
  <ng-multiselect-dropdown
    class="multiselect"
    [settings]="dropdownSettings"
    [placeholder]="'label.empty' | locCap"
    [data]="residentTypes"
    [(ngModel)]="residentTypesSelected"
    [ngModelOptions]="{ standalone: true }"
    (onSelect)="toggleResidentType(true, false, $event)"
    (onDeSelect)="toggleResidentType(false, false, $event)"
    (onSelectAll)="toggleResidentType(true, true)"
    (onDeSelectAll)="toggleResidentType(false, true)"
  >
  </ng-multiselect-dropdown>
</div>
<div>
  <label>{{ 'defect.unitType' | loc }}</label>
  <ng-multiselect-dropdown
    class="multiselect"
    [settings]="dropdownSettings"
    [placeholder]="'select.allF' | locCap"
    [data]="unitTypes"
    [(ngModel)]="unitTypesSelected"
    [ngModelOptions]="{ standalone: true }"
    (onSelect)="toggleUnitType(true, false, $event)"
    (onDeSelect)="toggleUnitType(false, false, $event)"
    (onSelectAll)="toggleUnitType(true, true)"
    (onDeSelectAll)="toggleUnitType(false, true)"
  ></ng-multiselect-dropdown>
</div>
<div>
  <label> {{ 'addr.blockNumber' | loc }} </label>
  <ng-multiselect-dropdown
    class="multiselect"
    [settings]="dropdownSettings"
    [placeholder]="'select.allF' | locCap"
    [data]="allData.buildings"
    [(ngModel)]="selected.buildings"
    [ngModelOptions]="{ standalone: true }"
    (onSelect)="toggleBuilding($event, true)"
    (onDeSelect)="toggleBuilding($event, false)"
    (onSelectAll)="toggleAllBuildings(true)"
    (onDeSelectAll)="toggleAllBuildings(false)"
  >
  </ng-multiselect-dropdown>
</div>
<div *ngIf="filtered.staircases.length">
  <label> {{ 'addr.staircase' | loc }} </label>
  <ng-multiselect-dropdown
    class="multiselect"
    [settings]="dropdownSettings"
    [placeholder]="'select.allF' | locCap"
    [data]="filtered.staircases"
    [(ngModel)]="selected.staircases"
    [ngModelOptions]="{ standalone: true }"
    (onSelect)="toggleStaircase($event, true)"
    (onDeSelect)="toggleStaircase($event, false)"
    (onSelectAll)="toggleAllStaircases(true)"
    (onDeSelectAll)="toggleAllStaircases(false)"
  >
  </ng-multiselect-dropdown>
</div>
<div *ngIf="filtered.numbers.length">
  <label>
    {{ 'addr.number' | loc }}
  </label>
  <ng-multiselect-dropdown
    class="multiselect"
    [settings]="dropdownSettings"
    [placeholder]="'select.allF' | locCap"
    [data]="filtered.numbers"
    [(ngModel)]="selected.numbers"
    [ngModelOptions]="{ standalone: true }"
    (onSelect)="toggleNumbers()"
    (onDeSelect)="toggleNumbers()"
    (onSelectAll)="toggleNumbers()"
    (onDeSelectAll)="toggleNumbers()"
  >
  </ng-multiselect-dropdown>
</div>
